import Box from '@/common/components/Box'
import Button from '@/common/components/Button'
import { MaintenanceSolicitationValidationSchema } from '@/features/privateCompanies/schemas/maintenanceSolicitations/create.schema'
import { XIcon } from 'lucide-react'
import { FieldArrayWithId, UseFieldArrayRemove } from 'react-hook-form'

interface MaintenanceSolicitationObjectivesProps {
  objectivesFields: FieldArrayWithId<MaintenanceSolicitationValidationSchema, 'objectives', 'id'>[]
  removeObjective: UseFieldArrayRemove
}

export const MaintenanceSolicitationObjectives = ({
  objectivesFields,
  removeObjective,
}: MaintenanceSolicitationObjectivesProps) => {
  return (
    <>
      {objectivesFields.map((field, index) => (
        <Box key={field.id} className="flex w-full flex-col gap-y-2 rounded-lg">
          <div className="flex w-full items-start justify-between">
            <Box className="bg-white-200 p-2">
              <p className="text-xs">{field.system_id.label}</p>
            </Box>

            <Button type="button" variant="outline-error" className="p-0" onClick={() => removeObjective(index)}>
              <XIcon strokeWidth={1} className="text-danger" />
            </Button>
          </div>

          <div>
            <p className="font-bold">{field.part_id.label}</p>
            <p className="text-[10px]">{field.action_id.label}</p>
          </div>
        </Box>
      ))}
    </>
  )
}
